import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import i18n from "../../../../i18n";
import { addModal } from "../../../../app.logic";
import { modalStyleForm } from "../../../../utils/constant";
import { conditionFormChecker, initUseForm } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { validateError } from "../../../../utils/validate";
import {
    createFieldDatetime,
    createFieldInput,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";

export const { isLoading, setIsLoading } = createLoading();

export const KadeeForm = defineAsyncComponent(() => import("./KadeeForm"));

export const openModalForm = ({ props, onOk, bind, data }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okText: i18n.global.t("button.close"),
                okButtonProps: { disabled: false },
                cancelButtonProps: { style: { display: 'none' }},
                title: i18n.global.t("views.kadee.name"),
                width: "600px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <KadeeForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
                form={data}
            ></KadeeForm>
        )
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        caseName: null,
        date: null,
        circumstance: null,
        complaints: [],
        arrestTeams: [],
        chargedDetails: [],
    };
};

export const createRules = () => {
    return {

    };
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return [
        {
            visible: () => !model?.date,
            colProp: () => ({ xs: 24 }),
            formItemRender: () => <div type="flex" justify="center" align="middle">{ i18n.global.t("views.kadee.notFound") }</div>
        },
        createFieldDatetime({
            visible: () => model?.date,
            key: `${prefix}date`,
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("views.kadee.arrestRecord.date"),
            inputProp: ({ field }) =>
                lodash.merge(
                    {
                        value: model?.date,
                        disabled: viewOnly
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                )
        }),
        createFieldTextArea({
            visible: () => model?.date,
            key: `${prefix}circumstance`,
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("views.kadee.arrestRecord.circumstance"),
            inputProp: ({ field }) =>
                lodash.merge(
                    {
                        value: model.circumstance,
                        disabled: viewOnly,
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                ),
        }),
        createFieldInput({
            visible: () => model?.date,
            key: `${prefix}criminalCase`,
            colProp: () => ({ xs: 24, md: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => `${i18n.global.t("views.kadee.complaint.criminalNumber")}`,
            inputProp: ({ field }) =>
                lodash.merge(
                    {
                        value: model?.complaints?.[0]?.criminalNumber,
                        disabled: true,
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                ),
        }),
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
